import { useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderedCatsCollarUnits } from '@store/partners-order/selectors';
import { updateOrderedCatsCollarUnitsItem } from '@store/partners-order/slice';
import SizeItem from '@pages/partners-order/sizes-units/SizeItem';



const CatsCollarSizesGrid = () => {
	
	const orderedCatsCollarUnits = useSelector(selectOrderedCatsCollarUnits);
	const dispatch = useDispatch();
	const updateCatsCollarUnitsItem = (label: string, value: number) => dispatch(updateOrderedCatsCollarUnitsItem({ label, value }));


	const sizesArray = useMemo((): Array<{ label: string, value: number }> => {
		return [
			{ label: 'S', value: orderedCatsCollarUnits.sizeS },
			{ label: 'M', value: orderedCatsCollarUnits.sizeM },
			{ label: 'L', value: orderedCatsCollarUnits.sizeL },
		];
	},[ orderedCatsCollarUnits ]);

	
	return (
		<div className='cats-sizes-grid'>
			{sizesArray.map(x =>
				<SizeItem
					label={x.label}
					count={x.value}
					onClick={updateCatsCollarUnitsItem}
					key={`size-item-cat-collar-${x.label}`} />)}
		</div>
	);
};

export default memo(CatsCollarSizesGrid);